export default function() {
  const offset = new Date().getTimezoneOffset();

  return `(GMT ${offset >= 0 ? '-' : '+'}${Math.abs(offset / 60)
    .toString()
  })`;
}
